export type Origin =
    | "border-box"
    | "padding-box"
    | "content-box"
    | "initial"
    | "inherit";

export function isOrigin(value: string): value is Origin {
    return [
        "border-box",
        "padding-box",
        "content-box",
        "initial",
        "inherit"
    ].includes(value);
}
